var map = {
	"./cs/core": [
		2315,
		315
	],
	"./da/core": [
		1576,
		576
	],
	"./de/core": [
		2116,
		116
	],
	"./en/core": [
		2764
	],
	"./es/core": [
		2065,
		65
	],
	"./fr/core": [
		1269,
		269
	],
	"./it/core": [
		4422,
		422
	],
	"./ja/core": [
		2326,
		326
	],
	"./ko/core": [
		1855,
		855
	],
	"./pl/core": [
		5665,
		665
	],
	"./pt-BR/core": [
		3500,
		500
	],
	"./ru/core": [
		3466,
		466
	],
	"./sk/core": [
		6755,
		755
	],
	"./sv/core": [
		2150,
		150
	],
	"./uz/core": [
		5264,
		264
	],
	"./zh/core": [
		4583,
		583
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5165;
module.exports = webpackAsyncContext;